import React from 'react'

function ViewReceiptPayments() {
  return (
    <div>ViewReceiptPayments</div>
  )
}

export default ViewReceiptPayments